import * as Images from "../assets";

export const ListaRopa = [
    {
        id: 0,
        image_f: Images.Remera1F,
        image_b: Images.Remera1B,
        nombre: "Camiseta Nubes",
        descripcion: "Camiseta de remil nubes",
        precio: 5000,
        stock: 9,
        categoria: "camiseta",
    },
    {
        id: 1,
        image_f: Images.Pantalon1F,
        image_b: Images.Pantalon1B,
        nombre: "Camiseta Negra",
        descripcion: "Camiseta remil negra",
        precio: 5000,
        stock: 9,
        categoria: "pantalon",
    },
    {
        id: 2,
        image_f: Images.Zapatilla1F,
        image_b: Images.Zapatilla1B,
        nombre: "Camiseta Negra",
        descripcion: "Camiseta remil negra",
        precio: 5000,
        stock: 9,
        categoria: "zapatilla",
    },
    {
        id: 3,
        image_f: Images.Buzo1F,
        image_b: Images.Buzo1B,
        nombre: "Camiseta Negra",
        descripcion: "Camiseta remil negra",
        precio: 5000,
        stock: 9,
        categoria: "buzo",
    },
];
